import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import { Resolve } from 'vue-di';
import { Settings } from '~/services/settings';

export interface IEligibilityData {
    eligibilityFederal?: string;
    diagnosis?: string;
    doesAgreeMarketing?: string;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    public eligibilityData: SurveySessionValueModel[] = [];

    public isEligible = false;

    public isMarketingOptInCheck = false;


    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityData | any) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    public checkPatientEligibility(eligibilityData: SurveySessionValueModel[], path: string) {
        let isEligible = false;
        if (path === 'HCP') {
            const correctAnswers = [
                +this.settings.hasBeenPrescribedAnswerYesIdHcpCablivi,
                +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
                +this.settings.isFederalAnswerYesIdHCP,
                +this.settings.isUSResidentAnswerYesIdHcp,
                +this.settings.iConsentAnswerYesIdHcp,
                +this.settings.medicationCabliviHcpAnswerId
            ] as number[];

            isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            this.updateIsEligible(isEligible);
        } else if (path === 'Patient') {
            // Patient Path
            const correctAnswers = [
                +this.settings.hasBeenPrescribedAnswerYesIdPatientCablivi,
                +this.settings.isCommerciallyInsuredAnswerYesIdPatient,
                +this.settings.isFederalAnswerNoIdPatient,
                +this.settings.isUSResidentAnswerYesIdPatient,
                +this.settings.isAbove18YearsOfAgeAnswerYesIdPatient,
                +this.settings.iConsentAnswerYesIdPatient,
                +this.settings.iSecondConsentQuestionYesIdPatient,
                +this.settings.medicationCabliviPatientAnswerId
            ] as number[];
            if (this.isMarketingOptInCheck) {
                correctAnswers.push(+this.settings.marketingOptInAnswerYesIdPatient);
                correctAnswers.push(+this.settings.marketingOptInAnswerNoIdPatient);
            }

            isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            this.updateIsEligible(isEligible);
        }
        return isEligible
    }
    @Mutation
    public async updateIsMarketingOptInCheck(isMarketingOptInCheck: boolean) {
        this.isMarketingOptInCheck = isMarketingOptInCheck;
    }


}
